import type { ProductLogoMediumProps } from "../types";

/**
 * 中サイズのCalendarロゴアイコン
 */
export function ProductLogoMediumCalendar({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" rx="5.88235" fill="#1A2142" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.6464 11.2942H10.5875V30.3531H29.6464V11.2942ZM10.5875 9.88247C9.80785 9.88247 9.17578 10.5145 9.17578 11.2942V30.3531C9.17578 31.1328 9.80785 31.7648 10.5875 31.7648H29.6464C30.4261 31.7648 31.0581 31.1328 31.0581 30.3531V11.2942C31.0581 10.5145 30.4261 9.88247 29.6464 9.88247H10.5875Z"
        fill="white"
      />
      <path
        d="M18.5875 17.6472C18.8474 17.6472 19.0581 17.8579 19.0581 18.1178V19.2942C19.0581 19.5541 18.8474 19.7648 18.5875 19.7648H17.4111C17.1512 19.7648 16.9405 19.5541 16.9405 19.2942V18.1178C16.9405 17.8579 17.1512 17.6472 17.4111 17.6472H18.5875Z"
        fill="white"
      />
      <path
        d="M22.8228 17.6472C23.0827 17.6472 23.2934 17.8579 23.2934 18.1178V19.2942C23.2934 19.5541 23.0827 19.7648 22.8228 19.7648H21.6464C21.3865 19.7648 21.1758 19.5541 21.1758 19.2942V18.1178C21.1758 17.8579 21.3865 17.6472 21.6464 17.6472H22.8228Z"
        fill="white"
      />
      <path
        d="M27.0581 17.6472C27.318 17.6472 27.5287 17.8579 27.5287 18.1178V19.2942C27.5287 19.5541 27.318 19.7648 27.0581 19.7648H25.8817C25.6218 19.7648 25.4111 19.5541 25.4111 19.2942V18.1178C25.4111 17.8579 25.6218 17.6472 25.8817 17.6472H27.0581Z"
        fill="white"
      />
      <path
        d="M27.0581 21.8825C27.318 21.8825 27.5287 22.0932 27.5287 22.3531V23.5295C27.5287 23.7894 27.318 24.0001 27.0581 24.0001H25.8817C25.6218 24.0001 25.4111 23.7894 25.4111 23.5295V22.3531C25.4111 22.0932 25.6218 21.8825 25.8817 21.8825H27.0581Z"
        fill="white"
      />
      <path
        d="M22.8228 21.8825C23.0827 21.8825 23.2934 22.0932 23.2934 22.3531V23.5295C23.2934 23.7894 23.0827 24.0001 22.8228 24.0001H21.6464C21.3865 24.0001 21.1758 23.7894 21.1758 23.5295V22.3531C21.1758 22.0932 21.3865 21.8825 21.6464 21.8825H22.8228Z"
        fill="white"
      />
      <path
        d="M18.5875 21.8825C18.8474 21.8825 19.0581 22.0932 19.0581 22.3531V23.5295C19.0581 23.7894 18.8474 24.0001 18.5875 24.0001H17.4111C17.1512 24.0001 16.9405 23.7894 16.9405 23.5295V22.3531C16.9405 22.0932 17.1512 21.8825 17.4111 21.8825H18.5875Z"
        fill="white"
      />
      <path
        d="M14.3523 21.8825C14.6122 21.8825 14.8228 22.0932 14.8228 22.3531L14.8228 23.5295C14.8228 23.7894 14.6122 24.0001 14.3523 24.0001H13.1758C12.9159 24.0001 12.7052 23.7894 12.7052 23.5295V22.3531C12.7052 22.0932 12.9159 21.8825 13.1758 21.8825H14.3523Z"
        fill="white"
      />
      <path
        d="M14.3523 26.1178C14.6122 26.1178 14.8228 26.3285 14.8228 26.5884L14.8228 27.7648C14.8228 28.0247 14.6122 28.2354 14.3523 28.2354H13.1758C12.9159 28.2354 12.7052 28.0247 12.7052 27.7648V26.5884C12.7052 26.3285 12.9159 26.1178 13.1758 26.1178H14.3523Z"
        fill="white"
      />
      <path
        d="M18.5875 26.1178C18.8474 26.1178 19.0581 26.3285 19.0581 26.5884V27.7648C19.0581 28.0247 18.8474 28.2354 18.5875 28.2354H17.4111C17.1512 28.2354 16.9405 28.0247 16.9405 27.7648V26.5884C16.9405 26.3285 17.1512 26.1178 17.4111 26.1178H18.5875Z"
        fill="white"
      />
      <path
        d="M22.8228 26.1178C23.0827 26.1178 23.2934 26.3285 23.2934 26.5884V27.7648C23.2934 28.0247 23.0827 28.2354 22.8228 28.2354H21.6464C21.3865 28.2354 21.1758 28.0247 21.1758 27.7648V26.5884C21.1758 26.3285 21.3865 26.1178 21.6464 26.1178H22.8228Z"
        fill="white"
      />
      <path
        d="M29.6464 9.88247C30.4261 9.88247 31.0581 10.5145 31.0581 11.2942V15.5295L9.17578 15.5295L9.17578 11.2942C9.17578 10.5145 9.80785 9.88247 10.5875 9.88247H29.6464Z"
        fill="#57D7D9"
      />
      <path
        d="M15.5287 9.17659C15.5287 8.78674 15.2127 8.4707 14.8228 8.4707H14.117C13.7271 8.4707 13.4111 8.78674 13.4111 9.17659V11.2942C13.4111 11.6841 13.7271 12.0001 14.117 12.0001H14.8228C15.2127 12.0001 15.5287 11.6841 15.5287 11.2942V9.17659Z"
        fill="white"
      />
      <path
        d="M26.8228 9.17659C26.8228 8.78674 26.5068 8.4707 26.117 8.4707H25.4111C25.0212 8.4707 24.7052 8.78674 24.7052 9.17659V11.2942C24.7052 11.6841 25.0212 12.0001 25.4111 12.0001H26.117C26.5068 12.0001 26.8228 11.6841 26.8228 11.2942V9.17659Z"
        fill="white"
      />
    </svg>
  );
}
